import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ReportsPage } from './views/ReportsPage';

export const routes: RouteObject[] = [
  { path: 'reports', element: <ReportsPage /> },
];

export default routes;